import { render, staticRenderFns } from "./vendedorForm.vue?vue&type=template&id=9e06355c&scoped=true&"
import script from "./vendedorForm.vue?vue&type=script&lang=js&"
export * from "./vendedorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e06355c",
  null
  
)

export default component.exports